import { render, staticRenderFns } from "./news-add.vue?vue&type=template&id=25af52f6&scoped=true&"
import script from "./news-add.vue?vue&type=script&lang=ts&"
export * from "./news-add.vue?vue&type=script&lang=ts&"
import style0 from "./news-add.vue?vue&type=style&index=0&id=25af52f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af52f6",
  null
  
)

export default component.exports